import { render, staticRenderFns } from "./LargeRoundIcon.vue?vue&type=template&id=bdd33d2c&scoped=true&"
import script from "./LargeRoundIcon.vue?vue&type=script&lang=ts&"
export * from "./LargeRoundIcon.vue?vue&type=script&lang=ts&"
import style0 from "./LargeRoundIcon.vue?vue&type=style&index=0&id=bdd33d2c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bdd33d2c",
  null
  
)

export default component.exports